// extracted by mini-css-extract-plugin
export default {"technologyItem":"TechnologyItem_technologyItem__qyRJK","logo":"TechnologyItem_logo__yl41N"};